import { Row, RowProps } from 'antd';

interface RowSizeProps {
  children: React.ReactNode;
  className?: string;
  rowProps?: RowProps;
  fullWidth?: boolean
}

export const RowSize = ({ rowProps, className, children, fullWidth = true }: RowSizeProps) => {
  return (
    <Row
      gutter={rowProps?.gutter ?? [15, 15]}
      className={`${fullWidth ? 'w-100': ''} ${className}`}
      {...rowProps}
    >
      {children}
    </Row>
  );
};
